import api from "@api";
import { IFeatureKey, IFeature } from "../types";

const API_PATH = "feature_flags";

export const getFeature = async <F extends IFeature>(key: IFeatureKey) => {
  return await api.get<IFeatureKey, F>([API_PATH, key].join("/"));
};
